export const AddonInitialState = {
  addonList: [],
  selectedAddon: null,
  addedAddons: [],
  setCurrentAddonToAdd: null,
  selectedAddonArray: [],
};
